<template>
  <component
    class="relative whitespace-no-wrap group inline-block outline-none underline-none rounded-0 bg-transparent border-2 hover:text-white p-5 focus:outline-none text-xs uppercase font-bold tracking-md"
    :is="link ? 'router-link' : 'button'"
    :class="[`border-${color}`, `text-${color}`, `hover:bg-${color}`, { 'loading': loading }]"
    :type="link ? '' : type"
    :to="link"
    :disabled="disabled"
    id="button"
  >
    <span :style="(loading) ? { 'visibility': 'hidden' } : {}">
      <slot>
        Button
      </slot>
    </span>
    <loader :class="`text-${color} group-hover:text-white`" v-if="loading" />
  </component>
</template>

<script>
import Loader from './Loader.vue'

export default {
  name: 'ButtonOutline',
  mounted () {
  },
  props: {
    type: {
      type: String,
      required: false,
      default: 'button'
    },
    color: {
      type: String,
      required: false,
      default: 'primary'
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    link: {
      type: [Object, String],
      required: false,
      default: null
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    Loader
  }
}
</script>

<style lang="scss" scoped>
#button {
  border-style: inherit;
}
.loading {
  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -8px;
    margin-left: -8px;
    display: inline-block;
  }
}

button, a {
  &[disabled] {
    opacity: 0.5;
    cursor: not-allowed;
  }
}
</style>
